<template>
  <div class='limit-input-component'>
    <div><input type="text" class='input' v-model='strValue' :placeholder="placeholder" @change="onChange"></div>
    <div>建议输入字数 <span :class="{'red':strValue.length>limitNumber}">{{strValue.length}}</span>/{{limitNumber}}</div>
  </div>
</template>

<script type="text/babel">

  export default {
    data() {
      return {
        strValue: ''
      }
    },
    props: {
      limitNumber: {
        type: Number,
        default: 10
      },
      value: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: '请输入内容'
      }
    },
    watch:{
      value(){
        this.strValue = this.value
      }
    },
    methods: {
      onChange() {
        this.$emit('update:value', this.strValue)
      },
    }
  }

</script>